import { YOUTUBE_LINK_REGEXP } from "@/constants/reg";
import { parseQueryString } from "./urlUtils";

// 验证youtube 链接
export const isLinkYoutube = function (youtubeLink) {
    // youtube视频链接校验
    let flag = new RegExp(YOUTUBE_LINK_REGEXP, "i").test(youtubeLink);
    const link = JSON.parse(JSON.stringify(youtubeLink)).toString();
    if (flag) {
        const str = parseQueryString("v", youtubeLink);
        const regex = /[@. :$+;%{}]/;
        if (str) {
            flag = !(str.length > 0 && regex.test(str));
        }
    }
    //前两种正则未通过，链接不为空，包含youtube.com/shorts/
    if (youtubeLink !== "" && !flag && link.includes("youtube.com/shorts/")) {
        let link2 = link.replace("https://www.youtube.com/shorts/", "");
        link2 = link2.replace("https://youtube.com/shorts/", "");
        link2 = link2.replace("http://www.youtube.com/shorts/", "");
        link2 = link2.replace("http://youtube.com/shorts/", "");
        link2 = link2.replace("www.youtube.com/shorts/", "");
        link2 = link2.replace("youtube.com/shorts/", "");
        link2 = link2.replace("?feature=share", "");
        if (link2 !== "") {
            flag = true;
        }
    }
    return flag;
};

//是否以pc显示
export const isPCFunc = function () {
    const userAgentInfo = navigator.userAgent;
    const Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    let isPc = true;
    for (let i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
            isPc = false;
            break;
        }
    }
    if (document.documentElement.clientWidth <= 640) {
        isPc = false;
    }
    return isPc;
};
